// Color-coded extraction categories (Bahasa Indonesia)
export const CATEGORIES = {
  Fakta: {
    label: "Fakta",
    en: "Fact",
    dot: "bg-cyan-400",
    chip: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
    text: "text-cyan-300",
  },
  Klaim: {
    label: "Klaim",
    en: "Claim",
    dot: "bg-amber-400",
    chip: "bg-amber-500/10 text-amber-300 border-amber-500/30",
    text: "text-amber-300",
  },
  Disengketakan: {
    label: "Disengketakan",
    en: "Disputed",
    dot: "bg-rose-400",
    chip: "bg-rose-500/10 text-rose-300 border-rose-500/30",
    text: "text-rose-300",
  },
  Bukti: {
    label: "Bukti",
    en: "Evidence",
    dot: "bg-emerald-400",
    chip: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
    text: "text-emerald-300",
  },
  Isu_Hukum: {
    label: "Isu Hukum",
    en: "Legal Issue",
    dot: "bg-indigo-400",
    chip: "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
    text: "text-indigo-300",
  },
};

export const CATEGORY_ORDER = ["Fakta", "Klaim", "Disengketakan", "Bukti", "Isu_Hukum"];

export function catLabel(key, lang) {
  const c = CATEGORIES[key];
  if (!c) return key;
  return lang === "en" ? c.en : c.label;
}
